import React from 'react';

import { themes } from 'kb-shared';
import styled, { css } from 'styled-components';

type Props = {
  type?: string;
  buttons: React.ReactNode[];
  children: React.ReactNode;
};

export const Card: React.FC<Props> = ({ type, buttons, children }) => {
  return (
    <Container type={type}>
      {children}
      <ButtonContainer>{buttons}</ButtonContainer>
    </Container>
  );
};

//#region Styles
interface ContainerProps {
  type?: string;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;

  width: 100%;

  ${props =>
    props.type === 'mobile-no-padding' &&
    css`
      @media screen and ${themes.queries.mobile} {
        padding-left: 0;
        padding-right: 0;
      }
    `}
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  gap: 16px;
  margin-top: 16px;
`;
